import { Meter } from '@base-ui/react/meter';

import { InfoTooltip } from '@/components/ui/InfoTooltip';
import { cva, cx } from '@/cva.config';

export const subScoreIndicatorVariants = cva({
  base: 'h-full rounded-full transition-[width] duration-200',
  variants: {
    tier: {
      high: 'bg-score-high',
      low: 'bg-score-low',
      mid: 'bg-score-mid',
    },
  },
});

export const subScoreTier = (value: number, max: number) => {
  const ratio = value / max;

  if (ratio >= 0.75) {
    return 'high' as const;
  }

  if (ratio >= 0.5) {
    return 'mid' as const;
  }

  return 'low' as const;
};

interface SubScoreBarProps {
  info?: string;
  label: string;
  max?: number;
  value: number;
}

export const SubScoreBar = ({
  info,
  label,
  max = 25,
  value,
}: SubScoreBarProps) => {
  const tier = subScoreTier(value, max);
  return (
    <Meter.Root className="flex items-center gap-2.5" max={max} value={value}>
      <Meter.Label className="flex w-28 shrink-0 items-center gap-1 font-mono text-sm tracking-wide text-foreground-muted uppercase">
        {label}
        {info && <InfoTooltip body={info} label={label} placement="right" />}
      </Meter.Label>
      <Meter.Track className="h-1.5 flex-1 overflow-hidden rounded-full bg-border">
        <Meter.Indicator className={cx(subScoreIndicatorVariants({ tier }))} />
      </Meter.Track>
      <Meter.Value className="w-10 shrink-0 text-right font-mono text-xs text-foreground tabular-nums">
        {(_formatted, currentValue) => `${currentValue}/${max}`}
      </Meter.Value>
    </Meter.Root>
  );
};
